//import React, {useState} from "react"
import styled from "styled-components";
import * as Clrs from "../../src/js/colors";
//import { CSSTransition } from 'react-transition-group'
//import { rgba, shade, tint, darken } from "polished";
//import * as Colors from "../../ineight-global/js/colorVars"
//import * as Structs from "../../ineight-global/js/structureVars"

// --------------------- Grid Guide -------------------- //
// ----------------------------------------------------- //

// ----------------------------------------------------- //
// ----------------------------------------------------- //
//grid-auto-rows: min-content;

const FluidGrid = styled.div`
  display: grid;
  position: relative;
  width: ${(props) => (props.width ? props.width : "auto")};
  grid-template-columns: repeat(
    auto-fit,
    minmax(${(props) => (props.minwidth ? props.minwidth : "300px")}, 1fr)
  );
  grid-gap: ${(props) =>
    props.gap === "none"
      ? "0px"
      : props.gap === "narrow"
      ? "8px"
      : props.gap === "medium"
      ? "16px"
      : props.gap === "wide"
      ? "24px"
      : "16px"};
`;

export { FluidGrid };
